module.exports = __webpack_public_path__ + "fd6b3ee4f0ac734a74b8044cb7892f45.pdf";